module.exports = __webpack_public_path__ + "img/logo-min.f26102a8.png";